import React, { useEffect } from "react";
import { connect } from "react-redux";

import {
    Box,
    Card,
    CardHeader,
    CardContent,
    Container,
    Grid,
    Typography,
    LinearProgress,
} from "@mui/material";
import AppraisalTable from "../Appraisal/AppraisalTable";
import BreadcrumbBuilder from "../BreadcrumbBuilder";
import Error404 from "../../../Errors/Error404";
import Error500 from "../../../Errors/Error500";
import PDPTable from "../../PORT/PDP/PDPTable";
import RMSAvatar from "../RMSAvatar";

import { ActionTypes } from "../../../../constants";
import { getAppraisee, getRmsAppCode, getError } from "../../../../reducers";
import { getAppraiseeDetails } from "../../../../actions/rmsActions";

function Appraisee({ match, appraisee, getAppraiseeDetails, error, appCode }) {
    useEffect(() => {
        getAppraiseeDetails(match.params.uuid, appCode);
    }, [getAppraiseeDetails, match.params.uuid, appCode]);

    if (!!error) {
        if (error.errorCode === 404) {
            return <Error404 />;
        }
        if (error.errorCode === 500) {
            return <Error500 />;
        }
    }

    if (!appraisee) return <LinearProgress />;

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            avatar={
                                <RMSAvatar
                                    type={"appraisee"}
                                    badge={
                                        appraisee?.uuid?.length > 1
                                            ? ""
                                            : "warning"
                                    }
                                />
                            }
                            title={
                                <Typography
                                    component="h2"
                                    className="card-header-title"
                                >
                                    {appraisee?.name ?? "Appraisee"}
                                </Typography>
                            }
                            subheader={
                                <Typography
                                    component="span"
                                    className="card-header-subtitle"
                                >
                                    {appraisee?.jobRole ||
                                        "Job role not specified"}
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Box className="card-content">
                                <Box className="flex-container">
                                    <dl className="row-data">
                                        <dt>Area of work</dt>
                                        <dd>
                                            {appraisee?.areaOfWork?.name ||
                                                "Not specified"}
                                        </dd>
                                    </dl>
                                    <dl className="row-data">
                                        <dt>Organisation</dt>
                                        <dd>
                                            {appraisee?.organisation?.name ||
                                                "Not specified"}
                                        </dd>
                                    </dl>
                                    <dl className="row-data">
                                        <dt>Email</dt>
                                        <dd>
                                            {appraisee?.email ||
                                                "Not specified"}
                                        </dd>
                                    </dl>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography
                                    component="h2"
                                    className="card-header-title"
                                >
                                    PDP
                                </Typography>
                            }
                            subheader={
                                <Typography
                                    component="span"
                                    className="card-header-subtitle"
                                >
                                    Personal development plans
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Box className="card-content">
                                <PDPTable
                                    appraisee={{ uuid: appraisee?.uuid }}
                                    items={appraisee?.pdps}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card className="card">
                        <CardHeader
                            disableTypography={true}
                            title={
                                <Typography
                                    component="h2"
                                    className="card-header-title"
                                >
                                    Appraisal
                                </Typography>
                            }
                            subheader={
                                <Typography
                                    component="span"
                                    className="card-header-subtitle"
                                >
                                    Appraisal history
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Box className="card-content">
                                <AppraisalTable
                                    model="review"
                                    appraisee={{ uuid: appraisee?.uuid }}
                                    items={appraisee?.appraisals}
                                    isAppraiser={true}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Container>
    );
}

const mapStateToProps = (state, { match }) => ({
    appraisee: getAppraisee(state, match.params.uuid),
    error: getError(state, ActionTypes.GET_RMS_APPRAISEE_SUCCESS),
    appCode: getRmsAppCode(state),
});

export default connect(mapStateToProps, { getAppraiseeDetails })(Appraisee);
